import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Resource, ResourceState } from '../../types/resource';
import { v4 as uuidv4 } from 'uuid';

const initialState: ResourceState = {
  items: [],
  selectedResource: null,
  isLoading: false,
  error: null,
};

const resourceSlice = createSlice({
  name: 'resources',
  initialState,
  reducers: {
    addResource: (state, action: PayloadAction<Omit<Resource, 'id'>>) => {
      const newResource = { ...action.payload, id: uuidv4() };
      state.items.push(newResource);
    },
    updateResource: (state, action: PayloadAction<Resource>) => {
      const index = state.items.findIndex(item => item.id === action.payload.id);
      if (index !== -1) {
        state.items[index] = action.payload;
      }
    },
    deleteResource: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter(item => item.id !== action.payload);
    },
    setSelectedResource: (state, action: PayloadAction<Resource | null>) => {
      state.selectedResource = action.payload;
    },
  },
});

export const { addResource, updateResource, deleteResource, setSelectedResource } =
  resourceSlice.actions;
export default resourceSlice.reducer;
